import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { GRADIENTS, SHADOWS } from '@components/web/src/styles';

export const ScanResultModalContainer = styled(Flexbox)`
  background: ${GRADIENTS.warmGradientReversed()};
  border-radius: 16px;
  box-shadow: ${SHADOWS.xl};
`;

export const ContentWrapper = styled(Flexbox)`
  span {
    white-space: pre-line;
  }

  img {
    width: 100px;
    height: 100px;
  }

  button {
    margin-top: 16px;
    min-width: 150px;
  }
`;
